'use client'

import { useTranslations } from 'next-intl'
import ConfirmationDialog from './confirmation-dialog'

type PropsType = {
  open: boolean
  onConfirm: () => void
  onCancel: () => void
}

const UnsavedChangesGuardDialog = ({ open, onConfirm, onCancel }: PropsType) => {
  const t = useTranslations()

  return (
    <ConfirmationDialog
      open={open}
      onConfirm={onConfirm}
      onCancel={onCancel}
      title={t('unsaved_changes')}
      description={t('leave_page_description')}
      confirmText={t('leave_anyway')}
      cancelText={t('stay_on_page')}
      variant="destructive"
    />
  )
}

export default UnsavedChangesGuardDialog
